import { useNavigate } from "react-router-dom";
import { BottomSheet, UpgradeGateCard } from "./primitives";
import { UPGRADE_GATES } from "../../lib/upgradeGates";

// One sheet for every "upgrade moment"; the CTA opens the 3-option upgrade screen.
export function UpgradeMomentSheet({ gate, onClose, context = {} }) {
  const navigate = useNavigate();
  const preset = gate ? UPGRADE_GATES[gate] : null;
  return (
    <BottomSheet isOpen={!!preset} title="The Chalkboard" onDismiss={onClose}>
      {preset && (
        <div data-testid={`upgrade-moment-${gate}`}>
          <UpgradeGateCard
            {...preset}
            ctaLabel="See Chalkboard options →"
            context={context}
            onUpgrade={() => { onClose(); navigate("/app/upgrade"); }}
          />
        </div>
      )}
    </BottomSheet>
  );
}
